// #tag: AI INTELLIGENCE API CLIENT
// #purpose: Dispatches AI requests for engine health checks, smart document classification, optical intelligence, and exam syllabus summarization.
import { apiGet, apiPost } from './client';
import type { DocumentAnalysisResult } from '../types/documentIntelligence';

export interface DocumentSuggestResult {
  name: string;
  categoryId: string;
  subcategory: string;
  confidence: string;
}

export interface AiStatusResult {
  enabled: boolean;
  configured?: boolean;
  billingOk?: boolean;
  billingMessage?: string;
  features?: {
    naming?: boolean;
    analysis?: boolean;
    ocr?: boolean;
  };
  version?: string;
}

export function fetchAiStatus(): Promise<AiStatusResult> {
  return apiGet('/ai/status');
}

export function suggestDocumentName(input: {
  fileName: string;
  mimeType: string;
  previewImageBase64?: string;
  previewMimeType?: string;
}): Promise<DocumentSuggestResult> {
  return apiPost('/ai/document-suggest', input);
}

export function analyzeDocument(input: {
  fileName: string;
  mimeType: string;
  previewImageBase64?: string;
  previewMimeType?: string;
}): Promise<DocumentAnalysisResult> {
  return apiPost('/ai/document-analyze', input);
}

export function summarizeExam(input: {
  title: string;
  organization?: string;
  examCategory?: string;
  officialNotice?: string;
  importantDates?: Array<{ label: string; date: string }>;
}): Promise<{ summary: string[] }> {
  return apiPost('/ai/exam-summary', input);
}
